var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66665 5.33325V11.9999C4.66665 12.7363 5.2636 13.3333 5.99998 13.3333H9.99998C10.7364 13.3333 11.3333 12.7363 11.3333 11.9999V5.33325H12.6666V11.9999C12.6666 13.4727 11.4727 14.6666 9.99998 14.6666H5.99998C4.52722 14.6666 3.33331 13.4727 3.33331 11.9999V5.33325H4.66665Z",
    fill: "#840300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7.33325C6.29848 7.33325 6 7.63173 6 7.99992V10.6666C6 11.0348 6.29848 11.3333 6.66667 11.3333C7.03486 11.3333 7.33333 11.0348 7.33333 10.6666V7.99992C7.33333 7.63173 7.03486 7.33325 6.66667 7.33325Z",
    fill: "#840300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 7.33325C8.96514 7.33325 8.66667 7.63173 8.66667 7.99992V10.6666C8.66667 11.0348 8.96514 11.3333 9.33333 11.3333C9.70152 11.3333 10 11.0348 10 10.6666V7.99992C10 7.63173 9.70152 7.33325 9.33333 7.33325Z",
    fill: "#840300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33335 3.99992V3.33325C5.33335 2.22868 6.22878 1.33325 7.33335 1.33325H8.66669C9.77126 1.33325 10.6667 2.22868 10.6667 3.33325V3.99992H12.6667C13.0349 3.99992 13.3334 4.2984 13.3334 4.66659C13.3334 5.03478 13.0349 5.33325 12.6667 5.33325H3.33335C2.96516 5.33325 2.66669 5.03478 2.66669 4.66659C2.66669 4.2984 2.96516 3.99992 3.33335 3.99992H5.33335ZM6.66669 3.33325C6.66669 2.96506 6.96516 2.66659 7.33335 2.66659H8.66669C9.03488 2.66659 9.33335 2.96506 9.33335 3.33325V3.99992H6.66669V3.33325Z",
    fill: "#840300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash_can.186198ca23b8f12f2b5588b73ba7e525.svg";
export { ForwardRef as ReactComponent };